import * as React from 'react'
import PropTypes from 'prop-types'
import useFileLoader from 'utilities/useFileLoader'
import FileUploadContent from 'components/files/FileUploadContent/FileUploadContent'
import './FileUpload.scss'

const FileUpload = ({
  onLoad,
  isDragging,
  hasError,
  disabled,
  className,
}) => {
  const {
    FileDropOrBrowse,
  } = useFileLoader({
    onLoad,
    inputId: "file-upload",
  })

  return <FileDropOrBrowse
    className={`file-upload${isDragging ? ' dragging' : ''}${className ? ` ${className}` : ''}${disabled ? ' disabled' : ''}`}
  >
    <FileUploadContent
      isDragging={isDragging}
      hasError={hasError}
      disabled={disabled}
    />
  </FileDropOrBrowse>
}

FileUpload.propTypes = {
  onLoad: PropTypes.func,
  isDragging: PropTypes.bool,
  hasError: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default FileUpload